const copyTextToClipboard = ({ text, isPopover }) => {
  var textArea = document.createElement('textarea');

  textArea.style.position = 'absolute';
  textArea.style.top = 0;
  textArea.style.left = 0;

  textArea.style.width = '2em';
  textArea.style.height = '2em';

  textArea.style.padding = 0;

  textArea.style.border = 'none';
  textArea.style.outline = 'none';
  textArea.style.boxShadow = 'none';

  textArea.style.background = 'transparent';

  textArea.style.zIndex = 1400;

  textArea.value = text;

  
  try {
    if (isPopover) {
      document.getElementById('popover-content').appendChild(textArea);
    } else {
      document.body.appendChild(textArea);
    }
    textArea.focus();
    textArea.select();
    var successful = document.execCommand('copy');
  } catch (err) {
    console.error('unable to copy');
  }
  if (isPopover) {
    document.getElementById('popover-content').removeChild(textArea);
  } else {
    document.body.removeChild(textArea);
  }
};

export default copyTextToClipboard;
